import { render, staticRenderFns } from "./FavList.vue?vue&type=template&id=58d77675&scoped=true&"
import script from "./FavList.vue?vue&type=script&lang=js&"
export * from "./FavList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d77675",
  null
  
)

export default component.exports